import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coutr-proceeding-menu',
  templateUrl: './coutr-proceeding-menu.component.html',
  styleUrls: ['./coutr-proceeding-menu.component.css']
})
export class CoutrProceedingMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/court-proceedings/coutr-proceeding-menu/coutr-proceeding-menu.component.ts